var underDampedSpring = function underDampedSpring() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
};

var criticallyDampedSpring = function criticallyDampedSpring(target) {
  return {
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};

var linearTween = function linearTween() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
};

var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
var defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
};

var getDefaultTransition = function getDefaultTransition(valueKey, _ref) {
  var keyframes = _ref.keyframes;

  if (keyframes.length > 2) {
    return keyframesTransition;
  } else {
    var factory = defaultTransitions[valueKey] || defaultTransitions.default;
    return factory(keyframes[1]);
  }
};

export { criticallyDampedSpring, getDefaultTransition, linearTween, underDampedSpring };